import { bool, shape, string } from 'prop-types';
import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import BundleBadge from '../../../ProductBadges/BundleBadge';

const ProductBadge = ({ badge, playVideo }) => {
    const { text = '', type = '' } = badge;

    const Badge = () => {
        const badgeClasses = dt([
            'absolute',
            'bg-white',
            'border-1',
            'border-gray-40',
            'border-solid',
            'font-sans',
            'font-bold',
            'inline-block',
            'lg:py-2',
            'px-2',
            'py-1',
            'rounded-r-md',
            'shadow-elevation1',
            'text-gray-15',
            'text-xs',
            'z-10',
            'left-0',
            'top-0',
            'translate-x-0',
            'translate-y-3',
        ]);
        return <div className={badgeClasses}>{text}</div>;
    };

    if (playVideo || !text) return null;

    return type === 'bundle' ? <BundleBadge text={text} /> : <Badge />;
};

ProductBadge.propTypes = {
    badge: shape({
        text: string,
        type: string,
    }),
    playVideo: bool,
};

ProductBadge.defaultProps = {
    badge: {},
    playVideo: false,
};

export default ProductBadge;
